import custFollowWithReportNoStrain from './custFollowWithReportNoStrain'
export default custFollowWithReportNoStrain
